import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { buttonVariants } from '~/components/ui/button'
import { SpaceSectionContent } from '~/domains/spaces/components/space-details/space-section-content'
import { SpaceSectionTitle } from '~/domains/spaces/components/space-details/space-section-title'

const refEmoji: Record<string, string> = {
	punctuality: '🕑',
	clean: '✨',
	movingFurnitures: '🪑',
	neighbor: '🤫',
	officeSupplies: '🖊',
	food: '👅',
}

const refRules = [
	['punctuality', 'clean', 'movingFurnitures'],
	['neighbor', 'officeSupplies', 'food'],
]

export const SpaceRules = () => {
	const { t } = useTranslation()

	return (
		<SpaceSectionContent
			id='rules'
			className='container'
		>
			<SpaceSectionTitle>
				{t('space:sections.rules.title.long')}
			</SpaceSectionTitle>

			<p>{t('space:sections.rules.body')}</p>

			<div className='text-sm md:grid md:grid-cols-2 md:gap-8'>
				{refRules.map((group, i) => (
					<div
						key={i}
						className='flex flex-col gap-4'
					>
						{group.map((key) => (
							<div key={key}>
								<h3 className='flex flex-row items-center gap-2 font-bold'>
									<span className='text-3xl'>{refEmoji[key]}</span>

									{t(`space:sections.rules.${key}.title`)}
								</h3>

								{t(`space:sections.rules.${key}.body`)}
							</div>
						))}
					</div>
				))}
			</div>

			<Link
				href='https://preprod.cocoon-space.com/reglement-cocoon'
				target='_blank'
				className={buttonVariants({
					variant: 'outline',
					className: 'self-start',
				})}
			>
				{t('space:sections.rules.usageRulesBtn')}
			</Link>
		</SpaceSectionContent>
	)
}
